export default "__VITE_ASSET__B0y5Zdou__"